import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisDialogForm from "../../components/formdialog";
import JisTabButton from "../../components/controls/jisTabButton";
import DeadlineBadge from "../../components/controls/deadlinebadge";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";

import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";

function CaseAssignmentJudge() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert,holidays } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isCmc, setIsCmc] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [roles, setRoles] = useState([]);
  const [judges, setJudges] = useState([]);
  const [selectedCases, setSelectedCases] = useState({});
  const [assignTo, setAssignTo] = useState(null);
  const [tab, setTab] = useState("pending");
  const [judgeSearch, setJudgeSearch] = useState("");
  const [filteredJudges, setFilteredJudges] = useState([]);

  console.log({ selected });

  const [roleCase, setRoleCase] = useState("all");
  useEffect(() => {
    onLoadRoles();
  }, []);

  useEffect(() => {
    if (search != null) {
      if (pageIndex >= 0) {
        onSearch(search);
      } else {
        setPageIndex(0);
      }
    }
  }, [pageIndex, pageSize, search, tab]);

  const onCheck = (value, opt) => {
    let sel = selected;
    let updateSel = { ...selectedCases };
    if (value) {
      sel.add(opt.caseId);
      updateSel[opt.caseId] = opt;
    } else {
      sel.delete(opt.caseId);
      delete updateSel[opt.caseId];
    }
    setSelected(new Set(sel));
    setSelectedCases(updateSel);
    console.log(Object.keys(updateSel));
  };
  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-assigment/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data, "hello world");
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-assigment/${pageIndex}/${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadRoles = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getrolesBySearch/judge`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setRoles(data.roles);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadUserByRoleandDivision = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getUsersByRole/${option.roleId}/${option.divisionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setJudges(data.pros);
        setFilteredJudges(data.pros);
        setJudgeSearch("");
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  // Filter judges based on search
  useEffect(() => {
    if (judgeSearch.trim() === "") {
      setFilteredJudges(judges);
    } else {
      const searchLower = judgeSearch.toLowerCase();
      const filtered = judges.filter((judge) => {
        const fullName = Constants.judgeName(judge).toLowerCase();
        return fullName.includes(searchLower);
      });
      setFilteredJudges(filtered);
    }
  }, [judgeSearch, judges]);

  useEffect(() => {
    if (
      !(option.divisionId == null || option.divisionId == "") &&
      !(option.roleId == null || option.roleId == "")
    ) {
      setAssignTo(null);
      setJudges([]);
      onLoadUserByRoleandDivision();
    }
  }, [option.divisionId, option.roleId]);

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    navigate(`/case-details/${fee.caseId}`);
    // setActive(fee);
    // setIndex(ind);
    // setOpenCase(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
  };
  const onSave = async (e) => {
    e.preventDefault();
    if (option.caseFilingId == 1 && isCmc == null) {
      setErr("Please select the Case Event Option");
      return;
    }

    if (assignTo == null) {
      setErr("Please selecte one of the listed Judges");
      return;
    }

    var caseids = Array.from(selected);
    setErr("");
    var judgeAs = isCmc == true ? "CMC" : "Trial";
    var approve = {
      ...option,
      isCms: isCmc,
      caseids: caseids,
      assignType: "judge",
      judgeAs: judgeAs,
      assignTo: assignTo,
    };

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/Assign-Cases`, {
        method: "POST",
        body: JSON.stringify(approve),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);

        if (isCmc == false) {
          setAlert({
            open: true,
            title: "Case Assignment",
            subtitle: "Trial Cases assigned successfully",
          });
        } else {
          setAlert({
            open: true,
            title: "Case Assignment",
            subtitle: "CMC Cases assigned  successfully",
          });
        }
        setPageIndex(-1); // this will auto load again
        setSelectedCases({}); //reset the value
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };
  const onProcess = () => {
    const oneof = Object.values(selectedCases)[0];
    console.log(oneof, "yes one of");
    const optionData = {
      ...option,
      divisionId: oneof.divisionId,
      caseFilingId: oneof.caseFilingId,
    };
    console.log(optionData, "test yo");
    navigate("/bulk-assignment", {
      state: {
        selectedCases: selectedCases,
        selected: Array.from(selected),
        option: optionData,
      },
    });
  };

  const handleCancelSelection = () => {
    setSelectedCases({});
    setSelected(new Set());
  };

  return (
    <div>
      {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader onSearch={onSearch} frequentData={frequentData} />
      <div className="tab_body ">
        <div className="exportdiv">
          <img src={wordicon} />
          <img src={excelicon} />
          <img src={pdficon} />
        </div>

        <div className="case-assignment-tab-container">
          <div className="tab_section">
            <JisTabButton
              isActive={tab == "pending"}
              title="Pending"
              isRoleBased={false}
              onClick={() => setTab("pending")}
            />
            <JisTabButton
              isActive={tab == "assigned"}
              title="Assigned"
              isRoleBased={false}
              onClick={() => setTab("assigned")}
            />
          </div>

          <div className="case-assignment-btn-container">
            {Object.keys(selectedCases).length > 0 && (
              <>
                <button
                  className="case-assignment-btn-solid"
                  onClick={onProcess}
                >
                  {Object.keys(selectedCases).length === 1
                    ? "Assign (1)"
                    : `Bulk Assign (${Object.keys(selectedCases).length})`}
                </button>
                <button
                  onClick={handleCancelSelection}
                  className="case-assignment-btn-outline"
                >
                  Cancel selection
                </button>
              </>
            )}
          </div>
        </div>
        <div className="tab_view">
          {cases?.length == 0 && <JisEmptyList />}
          {cases?.length > 0 && (
            <div className="table">
              <div class="section-cases">
                <span>Assignment Cases</span>
                {/* <span className="total">{count}</span> */}
              </div>
              <div className="table-wrapper">
                <table className="case-table">
                  <thead>
                    <tr>
                      <th className="col-title">Suit Number</th>
                      <th className="col-title">Case Title</th>
                      <th className="col-medium">Filing Type</th>
                      {tab === "assigned" && (
                        <>
                          <th>Judge</th>
                          <th className="col-medium">Assignment Type</th>
                        </>
                      )}
                      <th className="col-medium">Classification</th>
                      <th className="col-medium">Case Age(Days)</th>
                      <th className="col-medium">Date Initiated</th>
                      <th className="col-medium">Status Level</th>
                      {/* <th>SLA</th> */}
                      <th className="col-title">Details</th>
                      { <th className="col-action">{tab === "pending"?'Assign':'Re-assign'} </th>}
                    </tr>
                  </thead>
                  <tbody>
                    {cases?.map((opt, index) => {
                      const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                      return (
                        <tr key={index}>
                          <td
                            style={{
                              backgroundColor: `${
                                Constants.getItemById(
                                  frequentData?.casecategories,
                                  opt.caseCategoryId,
                                )?.colour
                              }`,
                            }}
                          >
                            {opt.caseNumber || "N/A"}
                          </td>
                          <td>{opt.caseTitle || "N/A"}</td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casetype,
                              opt.caseTypeId,
                            )?.caseType1 || "N/A"}
                          </td>
                          {tab === "assigned" && (
                            <>
                              <td>
                                {Constants.judgeName(opt.judge, "N/A")}
                              </td>
                              <td>{opt.judgeAs ? opt.judgeAs : "N/A"}</td>
                            </>
                          )}
                          <td>
                            {" "}
                            {Constants.getItemById(
                              frequentData?.casecategories,
                              opt.caseCategoryId,
                            )?.categoryTitle || "N/A"}
                          </td>
                          <td>
                            {moment().diff(opt.createdOn, "days") || "N/A"}
                          </td>
                          <td>
                            {" "}
                            {Constants.momentDate(opt.createdOn).format(
                              "DD MMM, YYYY",
                            ) || "N/A"}
                          </td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casestatuses,
                              opt.caseStatusId,
                            )?.description || "N/A"}
                          </td>
                          {/* <td>
                            {" "}
                            <DeadlineBadge dateString={opt.slaExpire} />{" "}
                          </td> */}

                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onContinue(opt, index)}
                            >
                              View
                            </JisButton>
                          </td>
                          { (
                            <td>
                              <JisCheckbox
                                variant="plain"
                                onChange={(e) => onCheck(e, opt)}
                                value={selected.has(opt.caseId)}
                              />
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {cases?.length > 0 && (
                <Pagenated
                  onChangePageSize={(k) => setPageSize(k)}
                  size={pageSize}
                  total={count}
                  maxPage={20}
                  onPick={onPagePick}
                />
              )}
            </div>
          )}
        </div>
      </div>

      <BackLoader open={loading} />

      {openCase && active != null && (
        <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}
      {openOption && (
        <JisDialogForm
          title=" Case Assignment"
          onClose={() => setOpenOption(false)}
        >
          <form onSubmit={onSave}>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 3 }}>
                {option.caseFilingId == 1 && (
                  <JisYesNo
                    label="Assign Case As... "
                    value={isCmc}
                    yes="CMC"
                    no="Trial"
                    onChange={(e) => setIsCmc(e)}
                  />
                )}
                <div>
                  <div className="select-group">
                    <label>Division</label>
                    <select
                      name="divisionId"
                      value={option.divisionId}
                      onChange={onOptionChange}
                      required
                    >
                      <option value="">Select </option>
                      {frequentData.divisions?.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>Role:</label>
                    <select
                      name="roleId"
                      value={option.roleId}
                      onChange={onOptionChange}
                      required
                    >
                      <option value="">Select Role </option>
                      {roles?.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>
                      Judges:{" "}
                      <strong style={{ fontSize: 12 }}>
                        (Please select one of the Judges){" "}
                      </strong>
                    </label>
                    {judges?.length > 5 && (
                      <div style={{ marginBottom: "10px" }}>
                        <input
                          type="text"
                          placeholder="Search judges..."
                          value={judgeSearch}
                          onChange={(e) => setJudgeSearch(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "8px",
                            border: "1px solid #C8CACE",
                            borderRadius: "4px",
                            fontSize: "14px",
                          }}
                        />
                      </div>
                    )}
                    <div
                      className="content-box"
                      style={{ maxHeight: 300, overflowY: "auto" }}
                    >
                      {filteredJudges?.length === 0 ? (
                        <div
                          style={{
                            padding: "10px",
                            textAlign: "center",
                            color: "#666",
                          }}
                        >
                          {judges?.length === 0
                            ? "No judges available"
                            : "No judges found"}
                        </div>
                      ) : (
                        filteredJudges?.map((opt) => (
                          <div
                            key={opt.id}
                            onClick={() => setAssignTo(opt.id)}
                            className={`selected ${
                              opt.id === assignTo ? "active" : ""
                            }`}
                          >
                            {Constants.judgeName(opt)}
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
                <div className="input-group">
                  <label>
                    Comment <span className="required">*</span>{" "}
                  </label>
                  <div className="input-wrapper">
                    <DynamicIcon iname="group" />
                    <textarea
                      placeholder=" Comment"
                      name="comment"
                      required={true}
                      value={option.comment}
                      onChange={onOptionChange}
                    />
                  </div>
                </div>
                {err != "" && <div className="error">{err}</div>}
                <JisButton type="submit">Save </JisButton>{" "}
                <JisButton type="button" onClick={() => setOpenOption(false)}>
                  Cancel{" "}
                </JisButton>
              </div>
              <div style={{ flex: 1, maxHeight: 300 }} className="content-box">
                <div>
                  Selected Cases to Assign (
                  {Object.values(selectedCases).length})
                </div>
                {Object.values(selectedCases)?.map((opt, index) => (
                  <div className="selected" key={index}>
                    <div>{opt.caseNumber}</div>
                    <p style={{ fontSize: 12 }}>{opt.caseTitle}</p>
                  </div>
                ))}
              </div>
            </div>
          </form>
        </JisDialogForm>
      )}
    </div>
  );
}

export default CaseAssignmentJudge;
